export default __webpack_public_path__ + "static/media/heart_off.599b37f4.svg";